var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEye = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.7329 5.07648C13.0623 4.79888 15.4185 5.2913 17.4418 6.47853C19.465 7.66576 21.0441 9.48256 21.9379 11.6515C22.0213 11.876 22.0213 12.123 21.9379 12.3475C21.5704 13.2385 21.0847 14.076 20.4939 14.8375",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.0841 14.158C13.5183 14.7045 12.7605 15.0069 11.9739 15C11.1873 14.9932 10.4349 14.6777 9.87868 14.1215C9.32245 13.5652 9.00695 12.8128 9.00011 12.0262C8.99328 11.2396 9.29566 10.4818 9.84214 9.91602",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.479 17.4988C16.1525 18.2846 14.6725 18.7758 13.1394 18.9392C11.6063 19.1026 10.056 18.9343 8.59365 18.4457C7.13133 17.9571 5.79121 17.1597 4.66423 16.1075C3.53725 15.0554 2.64977 13.7731 2.06202 12.3478C1.97868 12.1233 1.97868 11.8763 2.06202 11.6518C2.94865 9.50164 4.50869 7.69704 6.50802 6.50879",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M2 2L22 22",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export { SvgEye as ReactComponent };
export default __webpack_public_path__ + "1702b80305ec7f3406a399772cec06ca.svg";